import { DatePipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { hasNoNextRun, isDate, isQueued, toDate } from '../utils/date.utils';

@Pipe({
    name: 'date',
    standalone: false
})
export class BaseDatePipe extends DatePipe implements PipeTransform {
    constructor(@Inject(LOCALE_ID) locale: string) {
        super(locale);
    }

    override transform(
        value: string | number | Date,
        format?: string | undefined,
        timezone?: string | undefined,
        locale?: string | undefined
    ): string | null;
    override transform(
        value: null | undefined,
        format?: string | undefined,
        timezone?: string | undefined,
        locale?: string | undefined
    ): null;
    override transform(
        value: string | number | Date | null | undefined,
        format?: string | undefined,
        timezone?: string | undefined,
        locale?: string | undefined
    ): string | null {
        if (value) {
            let input = value;
            if (!isDate(value)) {
                input = toDate(input.toString());
                if (isNaN(input)) {
                    throw new Error(`Unable to convert "${value}" into a date`);
                } else {
                    input = new Date(input);
                }
            }

            if (isQueued(input as Date)) return 'Queued';
            else if (hasNoNextRun(input as Date)) return '';
        }

        return super.transform(value, format, 'UTC', locale);
    }
}
